/* GG Hero — reveal del titolo parola-per-parola + tilt leggero sulla card */
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-gg-hero]').forEach(function (hero) {
    var heading = hero.querySelector('[data-gg-heading]');

    // Split del titolo in parole, ognuna con un delay progressivo.
    if (heading && !reducedMotion && !heading.dataset.ggSplit) {
      heading.dataset.ggSplit = 'true';
      var words = heading.textContent.trim().split(/\s+/);
      heading.textContent = '';
      words.forEach(function (word, i) {
        var outer = document.createElement('span');
        outer.className = 'gg-word';
        var inner = document.createElement('span');
        inner.textContent = word;
        inner.style.setProperty('--gg-d', 0.1 + i * 0.07 + 's');
        outer.appendChild(inner);
        heading.appendChild(outer);
        if (i < words.length - 1) heading.appendChild(document.createTextNode(' '));
      });
    }

    // Tilt molto leggero sulla card prodotto (solo pointer fine, no touch).
    var card = hero.querySelector('[data-gg-tilt]');
    if (card && !reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform =
          'perspective(900px) rotateY(' + (x * 4).toFixed(2) + 'deg) rotateX(' + (-y * 4).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    }
  });
})();
